<template>
	<main class="c-main">
		<div class="row">
			<div class="col-md-12">
				<b-collapse id="findCategoryBlock">
					<b-card>
						<input type="text" class="form-control" placeholder="Код категории"  v-model="titleOrCode"/>
						<div class="card-body" v-if="categories.length > 0">
							<table class="table table-bordered table-striped" id="serverDataTable">
								<thead>
									<tr>
										<th>ID</th>
										<th>Категория ( Код - Наименование)</th>
										<th>Категория относиться к</th>
										<th class="text-center">Действие</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(category, index) in categories" :key="index">
										<td>{{ category.id }}</td>
										<td>{{ category.code }} {{ category.title }}</td>
										<td>
											{{ category.parent == null  ? "Основная категория" : category.parent.title }}
										</td>
										<td class="text-center">
											<a class="btn btn-warning cursor mr-4" @click="getCategory(category.id)">Изменить</a>
											<a href="javascript:void(0);" @click="deleteCategory(category.id)" class="btn btn-danger">Удалить</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</b-card>
				</b-collapse>

				<div class="modal-mask" v-show="showCategoryModal" transition="modal">
					<div class="modal-wrapper">
						<div class="modal-container">
								<div class="modal-header"><slot name="header">Категория</slot></div>

								<div class="modal-body">
									<div class="form-group">
										<label>Заголовок</label>
										<input type="text" class="form-control" v-model="category.title" />
									</div>
									<div class="form-group">
										<label>Код</label>
										<input type="text" class="form-control" v-model="category.code" />
									</div>
									<div class="form-group">
										<label>Изменить категорию</label>
										<select class="form-control" v-model="category.parent_id">
											<option v-for="(item, index) in selectCategories" :key="index"
											:value="item.id"
											:selected="item.id == category.id"
											:disabled="item.id == category.id"
											>{{ item.title }}</option>
										</select>
									</div>
								</div>

								<div class="modal-footer">
									<slot name="footer">
										<button class="modal-button btn btn-danger" @click="closeCategoryModal()">Закрыть</button>
										<button class="modal-button btn btn-success" @click="categoryUpdate()">Изменить</button>
									</slot>
								</div>
						</div>
					</div>
			</div>
			</div>
		</div>
	</main>
</template>

<script>
import { GET, DELETE, POST } from "../../shared/api";
export default {
    props: ['selectCategories'],
    data() {
			return {
				showCategoryModal: false,
				titleOrCode: null,
				category: {
					parent_id: 0
				},
				searchValue: "",
				categories: [],
        awaitingSearch: false,
        searchTimeout: 2000,
			};
    },
    methods: {
			openCategoryModal() {
				this.showCategoryModal = true;
			},
			closeCategoryModal() {
				this.showCategoryModal = false;
			},
			getCategory(id) {
				for (var i = 0; i < this.categories.length; i++) {
					if(this.categories[i].id === id){
						this.category = this.categories[i]
					}
				}
				this.openCategoryModal();
			},
			findCategory() {
				GET([], "/findCategory/" + this.searchValue, this, false).then(response => {
					this.categories = response;
				});
			},
			categoryUpdate() {
				POST(this.category, "/categoryUpdate", this).then(response => {
					this.closeCategoryModal();
				});
			},
			deleteCategory(id) {
				DELETE(id, "/category/", this).then(response => {
					this.findCategory();
				});
			}
    },
    watch: {
			titleOrCode: function (value) {
				this.searchValue = value;
        if (!this.awaitingSearch) {
          setTimeout(() => {
            if(value !== ""){
              this.findCategory();
            } else {
              this.categories = []
            }
            this.awaitingSearch = false;
          }, this.searchTimeout); // 1 sec delay
        }
        this.awaitingSearch = true;
			},
    },
};
</script>
